var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{attrs:{"title":_vm.name}},[_vm._t("default",null,{"shortenedName":_vm.shortenedName})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }